import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import Form, { FormControl, FormRow } from 'rebook/apps/base/components/form/Form';
import Button from 'rebook/apps/base/components/Button';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';

import styles from './style.scss';


class TinyRegistrationForm extends React.Component {
  onBeforeSubmit() {
    ga('send', 'event', 'Registration', 'PushButton', this.props.GALabel);
  }

  onSuccess() {
    ga('send', 'event', 'Registration', 'Registration', this.props.GALabel);
    yaMetrikaReachGoal('Registration');
    if (this.props.onSuccess) {
      this.props.onSuccess();
    }
  }

  render() {
    const { onInit, onChange, onSubmit, onError, form, isInProgress,
      errorList, isAudioBook, booksPerSubscriptionCounter } = this.props;
    const label = `Введите вашу электронную почту и читайте эту и еще ` +
                  `${numberWithSpace(booksPerSubscriptionCounter.total)} книг!`;
    return (
      <div className="jest-bookpage-auth-form">
        <Form
          action="/api/registration/"
          method="post"
          onBeforeSubmit={() => this.onBeforeSubmit()}
          onSubmit={onSubmit}
          onSuccess={() => this.onSuccess()}
          onError={onError}>
          <FormRow extraClassName={classNames(styles.tinyRegistrationFormRow, 'jest-bookpage-auth-email')}>
            <FormTextInput
              name="email"
              isDisabled={isInProgress}
              isRequired
              isRequiredError="Введите почту"
              onInit={onInit}
              onChange={onChange}
              errorList={errorList.email}
              value={form.email && form.email.value}
              label={label} />
          </FormRow>
          <FormControl extraClassName={styles.tinyRegistrationControl}>
            <Button isInProgress={isInProgress}>
              {`${isAudioBook ? 'Cлушать' : 'Читать'} онлайн`}
            </Button>
          </FormControl>
        </Form>
      </div>
    );
  };
}

function mapStateToProps(state) {
  return {
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TinyRegistrationForm);
